import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter } from 'react-router-dom';

import {
    Button,
    SwipeableDrawer,
    List,
    ListItem,
    Hidden,
    Grid,
    IconButton,
    MenuItem,
    Menu,
    Divider,
} from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
import { connect } from 'react-redux';
import * as authAction from '../../store/Auth/Auth.action';
import { safeGet } from '../../axios-default';

let selfDesignPricingVisibilityCache = null;

const styles = (theme) => ({
    sideNav: {
        width: '238px',
        height: '100vh',
        position: 'fixed',
        color: 'white',
        textAlign: 'left',
        top: '0px',
        zIndex: 1,
    },
    buttonActive: {
        marginLeft: '8px',
        marginRight: '8px',
        width: 'calc( 100% - 16px)',
        background: '#404156',
        color: 'white',
        fontSize: '16px',
        textTransform: 'unset',
        '&:hover': {
            background: '#404156',
        },
    },
    logoutBtn: {
        margin: '8px',
        width: 'calc( 100% - 16px)',
        background: '#df4d4d',
        color: 'white',
        fontSize: '16px',
        textTransform: 'unset',
        '&:hover': {
            background: '#e47474',
        },
    },
    backToPlatform: {
        margin: '8px',
        width: 'calc( 100% - 16px)',
        background: '#547da8',
        color: 'white',
        fontSize: '16px',
        textTransform: 'unset',
        '&:hover': {
            background: '#8ac2fc',
        },
    },
    button: {
        marginLeft: '8px',
        marginRight: '8px',
        width: 'calc( 100% - 16px)',
        background: '#ffffff00',
        color: 'white',
        boxShadow: 'unset',
        fontSize: '16px',
        textTransform: 'unset',
        '&:hover': {
            background: '#404156',
            color: 'white',
        },
    },
    appBar: {
        [theme.breakpoints.between('md', 'xl')]: {
            width: 'calc(100% - 238px)',
            // backgroundColor: Colors.mainButton,
            marginLeft: '238px',
            height: 48,
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            // height: 128,
            // background: "url(../img/mobileBg.png)",
            backgroundSize: 'cover',
            width: '100%',
            filter: 'drop-shadow(5px 5px 5px #d1bebe)',
        },
        position: 'fixed',
        top: 0,
        zIndex: 1199,
        color: 'black',
        boxShadow: 'unset',
        color: 'white',
    },
    title: {
        margin: '8px 0px',
        textAlign: 'center',
    },
    navInner: {
        // [theme.breakpoints.between("xs", "sm")]:{
        //   paddingTop: "24px"
        // },
        padding: 4,
    },
    sideLogo: {
        fontSize: 28,
        color: 'white',
        textAlign: 'center',
        marginBlockStart: '10px',
        marginBlockEnd: 0,
    },
});

class SideNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pages: [
                {
                    name: 'Dashboard',
                    icon: '',
                    linkTo: '/admin/dashboard',
                },
                {
                    name: 'Accounts',
                    icon: '',
                    linkTo: '/admin/accounts',
                    roles: ['SADMIN', 'DISTR'],
                },
                {
                    name: 'Clinics',
                    icon: '',
                    linkTo: '/admin/clinics',
                },
                {
                    name: 'Groups',
                    icon: '',
                    linkTo: '/admin/groups',
                },
                {
                    name: 'DistrGroups',
                    icon: '',
                    linkTo: '/admin/distrgroups',
                    roles: ['SADMIN', 'ADMIN'],
                },
                {
                    name: 'AdminGroups',
                    icon: '',
                    linkTo: '/admin/admingroups',
                    roles: ['SADMIN'],
                },
                {
                    name: 'Cases',
                    icon: '',
                    linkTo: '/admin/cases',
                },
                {
                    name: 'Slow Moving Cases',
                    linkTo: '/admin/slow_moving_cases',
                },
                {
                    name: 'Cases Activity Log',
                    icon: '',
                    linkTo: '/admin/CasesActivityLog',
                },
                {
                    name: 'Cases Audit Trail',
                    icon: '',
                    linkTo: '/admin/tracelog',
                    roles: ['SADMIN', 'ADMIN'],
                },
                {
                    name: 'Cases Change Log',
                    icon: '',
                    linkTo: '/admin/caseslog',
                    roles: ['SADMIN', 'ADMIN'],
                },
                {
                    name: 'Cases Cancel Log',
                    icon: '',
                    linkTo: '/admin/casesRollbackLog',
                    roles: ['SADMIN', 'ADMIN'],
                },
                {
                    name: 'Cases Transfer Log',
                    icon: '',
                    linkTo: '/admin/casesTransferLog',
                    roles: ['SADMIN', 'ADMIN'],
                },
                {
                    name: 'Countries',
                    icon: '',
                    linkTo: '/admin/countries',
                    roles: ['SADMIN', 'ADMIN'],
                },
                {
                    name: 'Support and Resource',
                    icon: '',
                    linkTo: '/admin/supportresource',
                },
                {
                    name: 'Form Download',
                    icon: '',
                    linkTo: '/admin/formdownload',
                },
                {
                    name: 'Knowledge Base',
                    icon: '',
                    linkTo: '/admin/knowledgebase',
                },
                {
                    name: 'Distributor Message',
                    icon: '',
                    linkTo: '/admin/distrmsg',
                },
                {
                    name: 'Refinement Log',
                    icon: '',
                    linkTo: '/admin/refinementLog',
                },
                {
                    name: 'Reports',
                    icon: '',
                    linkTo: '/admin/reports',
                },
                // {
                //   name: "SubDomains",
                //   icon: "",
                //   linkTo: "/admin/subdomains",
                //   roles: ['SADMIN', 'ADMIN']
                // },
                {
                    name: 'Product List',
                    icon: '',
                    linkTo: '/admin/productmatrix',
                    roles: ['SADMIN', 'ADMIN', 'DISTR'],
                },
                {
                    name: 'Self-Design Pricing',
                    icon: '',
                    linkTo: '/admin/self-design-pricing',
                    roles: ['DISTR'],
                },
                {
                    name: 'Email Management',
                    icon: '',
                    linkTo: '/admin/email-management',
                    roles: ['SADMIN', 'ADMIN', 'DISTR'],
                },
                {
                    name: 'System Announcement',
                    icon: '',
                    linkTo: '/admin/systemAnnouncement',
                    roles: ['SADMIN'],
                },
                {
                    name: 'Settings',
                    icon: '',
                    linkTo: '/admin/settings',
                },
            ],
            left: false,
            anchorEl: null,
            settings: {},
            role: JSON.parse(localStorage.getItem('role')),
            selfDesignPricingVisible: selfDesignPricingVisibilityCache === true,
        };
    }

    componentDidMount() {
        if (!['ADMIN', 'DISTR', 'SADMIN'].includes(this.state.role)) {
            this.props.history.replace('/');
        }
        this.checkSelfDesignPricingVisibility();
    }

    checkSelfDesignPricingVisibility = async () => {
        const role = this.state.role;
        if (role !== 'DISTR') {
            this.setState({ selfDesignPricingVisible: false });
            return;
        }
        if (selfDesignPricingVisibilityCache !== null) {
            this.setState({ selfDesignPricingVisible: selfDesignPricingVisibilityCache });
            return;
        }
        try {
            const data = await safeGet('res/self-design-pricing/distr-groups');
            if (data.success && data.distr_groups) {
                const myDistrGroupId = JSON.parse(localStorage.getItem('distr_group_id'));
                const isVisible = data.distr_groups.some(
                    (d) => String(d.distr_group_id) === String(myDistrGroupId)
                );
                selfDesignPricingVisibilityCache = isVisible;
                this.setState({ selfDesignPricingVisible: isVisible });
            } else {
                selfDesignPricingVisibilityCache = false;
                this.setState({ selfDesignPricingVisible: false });
            }
        } catch (err) {
            console.error(err);
            selfDesignPricingVisibilityCache = false;
            this.setState({ selfDesignPricingVisible: false });
        }
    };

    componentWillUnmount() {}

    handleLogout = () => {
        this.props.logOut();
        // this.props.history.replace('/login')
    };

    toggleDrawer(side, open) {
        return () => {
            this.setState({
                [side]: open,
            });
        };
        // console.log(open)
    }

    returnPages() {
        return this.state.pages
            .filter(({ roles, name }) => {
                if (roles && !roles.includes(this.state.role)) return false;
                if (
                    name === 'Self-Design Pricing' &&
                    this.state.role === 'DISTR' &&
                    !this.state.selfDesignPricingVisible
                )
                    return false;
                return true;
            })
            .map((v) => {
                return (
                    <Link to={v.linkTo} key={v.name} style={{ textDecoration: 'none' }}>
                        <Button
                            variant="contained"
                            className={
                                this.props.location.pathname.includes(v.linkTo)
                                    ? this.props.classes.buttonActive
                                    : this.props.classes.button
                            }
                        >
                            {v.name}
                        </Button>
                    </Link>
                );
            });
    }

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { anchorEl } = this.state;
        return (
            <div>
                <div
                    className={this.props.classes.appBar}
                    style={{
                        backgroundColor: 'rgba(6,26,46,1)',
                    }}
                >
                    <Grid container className={this.props.classes.navInner}>
                        <Grid item xs={3}>
                            <Hidden mdUp>
                                <IconButton
                                    aria-label="Account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={this.toggleDrawer('left', true)}
                                    color="inherit"
                                    style={{
                                        marginTop: '6px',
                                    }}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Hidden>
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: 16 }}>
                            <Hidden mdUp>
                                <h3 style={{ textAlign: 'center' }}>TrioClear</h3>
                            </Hidden>
                        </Grid>
                        <Grid item xs={3} style={{ textAlign: 'right' }}>
                            {
                                <div style={{ paddingRight: 24 }}>
                                    {/* <IconButton
                  aria-owns={anchorEl ? 'simple-menu' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton> */}
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={this.handleClose}
                                        PaperProps={{
                                            style: {
                                                maxHeight: 48 * 4.5,
                                                width: 168,
                                                left: 'unset !important',
                                                right: '24px',
                                            },
                                        }}
                                    >
                                        <MenuItem onClick={this.handleClose}>Profile</MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                this.props.history.replace('/settings');
                                                this.handleClose();
                                            }}
                                        >
                                            Settings
                                        </MenuItem>
                                        <MenuItem onClick={this.handleLogout}>Logout</MenuItem>
                                    </Menu>
                                </div>
                            }
                        </Grid>
                    </Grid>
                </div>
                <Hidden smDown>
                    <nav className={this.props.classes.sideNav} style={{ backgroundColor: 'rgba(6,26,46,1)' }}>
                        <div className="navDiv">
                            <h1 className={this.props.classes.sideLogo}>TrioClear</h1>
                            <hr style={{ borderTop: 'white solid 2px', width: '50%' }} />
                            {this.returnPages()}
                            <a href="/" style={{ textDecoration: 'none' }}>
                                <Button variant="contained" className={this.props.classes.backToPlatform}>
                                    Back To Platform
                                </Button>
                            </a>
                            <Button
                                variant="contained"
                                className={this.props.classes.logoutBtn}
                                onClick={this.handleLogout}
                            >
                                Logout
                            </Button>
                        </div>
                    </nav>
                </Hidden>
                <SwipeableDrawer
                    open={this.state.left}
                    onClose={this.toggleDrawer('left', false)}
                    onOpen={this.toggleDrawer('left', true)}
                    PaperProps={{
                        style: {
                            width: 250,
                            background: '#061a2e',
                        },
                    }}
                >
                    <h1
                        style={{
                            fontSize: 28,
                            color: 'white',
                            fontFamily: "'Poppins', sans-serif !important",
                            textAlign: 'center',
                        }}
                    >
                        TrioClear
                    </h1>
                    <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.14)' }} />
                    <List style={{ width: '250px' }}>
                        {this.state.pages
                            .filter(({ roles, name }) => {
                                if (roles && !roles.includes(this.state.role)) return false;
                                if (
                                    name === 'Self-Design Pricing' &&
                                    this.state.role === 'DISTR' &&
                                    !this.state.selfDesignPricingVisible
                                )
                                    return false;
                                return true;
                            })
                            .map((v) => (
                                <Link to={v.linkTo} style={{ color: 'white', textDecoration: 'none' }} key={v.name}>
                                    <ListItem
                                        button
                                        style={{ textAlign: 'center' }}
                                        key={v.name}
                                        onClick={() => this.setState({ left: false })}
                                    >
                                        <div
                                            style={{
                                                flex: '1 1 auto',
                                                display: 'block',
                                                textAlign: 'center',
                                                margin: '4px 0px',
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: '1rem',
                                                    lineHeight: 1.5,
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {v.name}
                                            </span>
                                        </div>
                                    </ListItem>
                                </Link>
                            ))}
                        <a href="/" style={{ textDecoration: 'none' }}>
                            <Button variant="contained" className={this.props.classes.backToPlatform}>
                                Back To Platform
                            </Button>
                        </a>
                        <Button
                            variant="contained"
                            className={this.props.classes.logoutBtn}
                            onClick={this.handleLogout}
                        >
                            Logout
                        </Button>
                    </List>
                </SwipeableDrawer>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    logOut: () => dispatch(authAction.logOut()),
});

export default connect(null, mapDispatchToProps)(withStyles(styles)(withRouter(SideNav)));
